import { Badge, Box, JsonInput, Tooltip } from '@mantine/core';

const EventDataCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const eventDataJson = JSON.stringify(rowData.eventData);
    const hasEventData = eventDataJson != '{}';
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            {hasEventData ? (
                <Tooltip
                    p={0}
                    label={
                        <JsonInput
                            value={JSON.stringify(rowData.eventData)}
                            autosize={true}
                        />
                    }>
                    <Badge
                        size={'xs'}
                        color={'blue'}>
                        Hover
                    </Badge>
                </Tooltip>
            ) : (
                <Badge
                    size={'xs'}
                    color={'gray'}>
                    No event data
                </Badge>
            )}
        </Box>
    );
};

const EventDataColumn = () => ({
    accessorKey: 'eventData',
    header: 'Event Data',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <EventDataCell cell={cell} />,
});
export default EventDataColumn;
